import { z } from "zod";
import { AIMinutesTemplateSchema } from "../../models/aiMinutesTemplate.schema";

export const PrivateAIMinutesTemplateControllerResponseSchema = {
  listAIMinutesTemplates: AIMinutesTemplateSchema.array(),

  getAIMinutesTemplate: AIMinutesTemplateSchema.nullable(),

  createAIMinutesTemplate: AIMinutesTemplateSchema,

  updateAIMinutesTemplate: AIMinutesTemplateSchema,

  deleteAIMinutesTemplate: z.void(),
};
